<template>
  <div class="model-list">
    <div class="panel-title">
      适用于<span>{{school}}</span>
    </div>
    <div class="list">
      <div class="model-item" :class="{ choice: item.id === choice }" @click="$emit('update:choice', item.id)" v-for="(item, index) in list" :key="index">
        <div class="is-now" v-if="item.is_current">当前使用</div>
        <div class="model-price">
          <span class="unit">￥</span>
          <span class="wechatNumber">{{item.price}}</span>
        </div>
        <div class="info">
          <span>/{{item.month}}个月</span>
          <span class="wechatNumber" v-if="item.deposit * 1">/押金￥{{item.deposit}}</span>
          <img :src="IconFeedback" class="info-icon" v-if="item.deposit  * 1" @click.stop="ShowTips" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import list from './data'
  import { SetImage } from '@/utils/Image'
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        // list,
        // choice: 0
      }
    },
    methods: {
      ShowTips () {
        this.$ShowConfirm(
          this.text,
          {
            title: '押金说明',
            showCancel: false,
            messageAlign: 'left',
            confirmText: '我知道了'
          }
        )
      }
    },
    props: {
      school: null,
      text: null,
      choice: null,
      list: {
        type: Array,
        default: () => ([])
      }
    },
    computed: {
      ...mapState('Common', ['deposit_explain']),
      ...SetImage(['IconFeedback'])
    }
  }
</script>

<style lang="less" scoped>
  .model-list {
    .m(.3rem .24rem);
    .br(.1rem);
    .bg(#fff);
    .p(.3rem .3rem .06rem);
    .panel-title {
      .fz(.3rem);
      .c(#999);
      .mb(.6rem);
      span {
        .c(#333);
        font-weight: bold;
        .ml(.25rem);
      }
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .model-item {
        .w(3rem);
        .h(1.7rem);
        .br(.1rem);
        box-sizing: border-box;
        border: 1px solid #c4c4c4;
        .mb(.24rem);
        .pl(.2rem);
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        &.choice {
          .bg(#fffbf2);
          border-color: #e9cc8a;
          .info {
            .c(#b59065);
          }
        }
        .is-now {
          .w(1.18rem);
          .h(.4rem);
          .br(.2rem);
          .bg(#c6ab89);
          .c(#fff);
          .fz(.22rem);
          .flex-ccc();
          position: absolute;
          top: .38rem;
          right: .15rem;
        }
        .model-price {
          .c(#8d5b20);
          .fz(.28rem);
          display: flex;
          align-items: flex-end;
          .lh(1);
          .mb(.2rem);
          .unit {
            transform: translateY(-.06rem);
          }
          .wechatNumber {
            .fz(.48rem);
            .lh(1);
          }
        }
        .info {
          .h(.3rem);
          .flex-c();
          .fz(.24rem);
          .c(#999);
          .info-icon {
            .w(.3rem);
            .h(.3rem);
            .ml(.08rem);
          }
        }
      }
    }
  }
</style>
